import _ from "lodash";
import React, { useMemo, useState } from "react";
import CardHeader from "./common/CardHeader";
import CardSubheader from "./common/CardSubheader";
import CardPreviewImage from "./common/CardPreviewImage";
import CardFilterPills from "./common/CardFilterPills";
import CardDescription from "./common/CardDescription";
import CardVideo from "./common/CardVideo";
import constants from "../../config/constants";
import CardFooter from "./common/CardFooter";
import ShortFeedItem from "../common/ShortFeedItem";
import LogsService from "../../utils/logs";
import getEnvEndpoints from "../../utils/endpoints";
import { previewImageOfPost, mtStandardsBooks } from "../../utils/helper";
const endpoints = getEnvEndpoints();

const Video = ({
  post,
  lookup,
  showPmbokModal,
  showFeedbackModal,
  showShareModal,
  cardFilterSelected,
  canProceed,
  isAuthenticated,
  playlists,
  feedbackSentContentKeys,
  fullcard,
  propGroup,
  userLikes,
  feedbacks,
  contentKey,
  id
}) => {
  const [expanded, setExpanded] = useState(false);

  const mainContent = useMemo(() => {
    return _.find(post.referenceFiles, {
      fileKey: constants.fileKey.mainContent,
    });
  }, [post.referenceFiles]);

  const link = () => {
    // Check if video is external link
    return mainContent.fileFormat === constants.fileFormat.link;
  };

  const brightcove = () => {
    // Check if video is brightcove
    return mainContent.fileFormat === constants.fileFormat.brightcove;
  };

  const videoFile = () => {
    // If brightcove or external link return full url, else
    // use relative url
    if (brightcove() || link()) {
      return mainContent.filePath;
    }

    return mainContent.filePath
      ? mainContent.filePath
      : endpoints.baseContentUrl + mainContent.relativePath;
  };

  const toggleExpand = async () => {
    if (!canProceed()) {
      return;
    }

    if (!expanded) {
        if (post.isPublic && post.publishUntilDate && !((post.isPublic) && (new Date (post.publishUntilDate) > new Date()) )) {
        await LogsService.logViewItem({
          contentKey: post.contentKey,
          contentSubType: post.contentType,
        })
          .then(() => { })
          .catch(() => { });
      }
    }

    setExpanded(!expanded);
  };
  const previewImage = previewImageOfPost(post);
  return (
    <>
      {fullcard ? (
        <div
          className={
            "flex border border-gray-500 rounded-sm mb-5 " +
            (post.status !== "Published" ? "bg-gray-400" : "bg-white")
          }
        >
          <div className="w-full">
            <CardHeader
              post={post}
              showPmbokModal={showPmbokModal}
              canProceed={canProceed}
              booksList={mtStandardsBooks(lookup, "MTStandardsGuide")}
            />

            <div className="px-5 mt-4">
              <div>
                <CardSubheader subheader={post.title} />
              </div>
              {previewImage && !expanded && (
                <div className="relative" onClick={() => toggleExpand()}>
                  <div className="pin absolute image-overlay">
                    <i className="absolute fas fa-play-circle text-white text-4xl md:text-6xl cursor-pointer play-btn-positon" />
                  </div>
                  <CardPreviewImage previewImage={previewImage?.filePath || previewImage} />
                </div>
              )}

              {mainContent && expanded && (
                <CardVideo videoFile={videoFile} brightcove={brightcove} post={post} />
              )}

              <CardDescription post={post} />

              <CardFilterPills
                post={post}
                lookup={lookup}
                canProceed={canProceed}
                cardFilterSelected={cardFilterSelected}
              />
            </div>

            <CardFooter
              post={post}
              showShareModal={showShareModal}
              showFeedbackModal={showFeedbackModal}
              canProceed={canProceed}
              isAuthenticated={isAuthenticated}
              feedbackSentContentKeys={feedbackSentContentKeys}
              playlists={playlists}
              propGroup={propGroup}
              userLikes={userLikes}
              feedbacks={feedbacks}
              contentKey={contentKey}
              id={id}
            />
          </div>
        </div>
      ) : (
        <ShortFeedItem post={post} />
      )}
    </>
  );
};

export default Video;
